import script from "./user.vue?vue&type=script&setup=true&lang=js"
export * from "./user.vue?vue&type=script&setup=true&lang=js"

import "./user.vue?vue&type=style&index=0&id=b11e4082&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b11e4082"]])

export default __exports__